import { Link, useOutletContext, useParams } from 'react-router-dom';
import type { TenantOutletContext } from './tenant-layout';
import { CeremonyViewer } from '../ceremony-viewer/ceremony-viewer';

export function TenantCeremonyDetailPage() {
  const { tenant } = useOutletContext<TenantOutletContext>();
  const { ceremonyId } = useParams<{ ceremonyId: string }>();
  return <div className="space-y-6">
    <Link className="text-sm text-neutral-600 underline" to={`/t/${tenant.id}/ceremonies`}>← Ceremonies</Link>
    {ceremonyId ? <CeremonyViewer tenantId={tenant.id} ceremonyId={ceremonyId} /> : <p>No ceremony selected.</p>}
  </div>;
}
